import React, { useState } from "react";

import { Button, Divider } from "@mui/material";
import { Stack } from "@mui/system";

import { formatPhoneNumber } from "../../../Utils/PhoneNumber/PhoneNumber";
import { SideDrawer } from "../../atoms/Drawer/SideDrawer";
import {
  SubHeader,
  SubHeader2,
} from "../../atoms/Typography/SubHeader/SubHeader";

export const ViewLocationDetails = ({ close, data, OpenDrawer }) => {

  return (
    <>
      <SideDrawer
        headingText={"Location details"}
        width={"648px"}
        openDrawer={OpenDrawer}
        close={close}
        anchorDrawer={"right"}
      >
        <div>
          <Stack marginLeft={"24px"} rowGap={"20px"}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(2,1fr)",
                gap: "16px",
              }}
            >
              <Stack>
                <SubHeader
                  text={"Location ID"}
                />
                <SubHeader2 text={data.locID || "-"} />
              </Stack>

              <Stack>
                <SubHeader
                  text={"Location name"}
                />
                <SubHeader2 text={data.clinicName || "-"} />
              </Stack>

              <Stack>
                <SubHeader
                  text={"Province"}
                />
                <SubHeader2 text={data.province || "-"} />
              </Stack>

              <Stack>
                <SubHeader
                  text={"District"}
                />
                <SubHeader2 text={data.district || "-"} />
              </Stack>

              <Stack>
                <SubHeader
                  text={"City"}
                />
                <SubHeader2 text={data.city || "-"} />
              </Stack>

              <Stack>
                <SubHeader
                  text={"Zip code"}
                />
                <SubHeader2 text={data.zipCode || "-"} />
              </Stack>

              <Stack>
                <SubHeader
                  text={"Phone no."}
                />
                <SubHeader2
                  text={
                    data.phoneNumber
                      ? data?.phoneNumberDialCode +
                      " " +
                      formatPhoneNumber(data.phoneNumber)
                      : "-"
                  }
                />
              </Stack>

                <Stack>
                  <SubHeader text={"Email"} />
                  <SubHeader2 text={data.email || "-"} />
                </Stack>


              <Stack>
                <SubHeader
                  text={"Address"}
                />

                <SubHeader2
                  text={data.address.trim() === "" ? "-" : data.address.trim()}
                />
              </Stack>

            </div>

            <Divider style={{ width: "100%", marginBottom: "20px" }} />

            <Stack
              direction={"row"}
              spacing={2}
              width={"100%"}
              justifyContent={"flex-end"}
              marginTop={"19px"}
            >
            </Stack>
          </Stack>
        </div>
      </SideDrawer>

    </>
  );
};
export default ViewLocationDetails;
